import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from "./PurchaseOrderDetails.module.scss";
import CustomInputField from "../../../../CustomHTMLElements/CustomInputField";
import { ILoanInformation } from "../LoanInformation/util";
import moment from "moment";
const PurchaseOrderDetails = ({ data, refetchData }: ILoanInformation) => {
  const { register, setValue } = useForm();
  const currentClient =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.principal_name;
  const activeContractBuyer =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.has_contract_with_buyer;
  const currency = data?.data?.data?.loan_application_details[0]?.currency;
  const contractValue =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.contract_amount;
  const purchaseOrderAmountValue =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.purchase_order_amount;
  const valueOfOrderFulfilled =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.fulfilled_amount;
  const percentageOfOrderFulfilled =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.percent_of_order_fulfilled;
  const purchaseOrderNumber =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.purchase_order_number;
  const loanAmount =
    data?.data?.data?.loan_application_details[0]?.approved_amount;
  const transactionTimes =
    data?.data?.data?.loan_application_details[0]?.purchase_order_detail
      ?.number_of_transactions;
  const loanProduct =
    data?.data?.data?.loan_application_details[0]?.approved_loan_product_detail;

  const purchaseOrderDueDate = data?.data?.data?.loan_application_details[0]
    ?.purchase_order_detail?.due_date
    ? moment(
        data?.data?.data?.loan_application_details[0]?.purchase_order_detail
          ?.due_date,
      ).format("YYYY-MM-DD")
    : "";

  useEffect(() => {
    if (data?.data?.data?.loan_application_details.length > 0) {
      setValue("client", currentClient);
      setValue("activeContractBuyer", activeContractBuyer);
      setValue("currency", currency);

      setValue(
        "contractValue",
        contractValue ? Number(contractValue).toLocaleString("en-US") : null,
      );
      setValue(
        "purchaseOrderAmountValue",
        purchaseOrderAmountValue
          ? Number(purchaseOrderAmountValue).toLocaleString("en-US")
          : null,
      );
      setValue(
        "valueOfOrderFulfilled",
        valueOfOrderFulfilled
          ? Number(valueOfOrderFulfilled).toLocaleString("en-US")
          : null,
      );

      setValue("percentageOfOrderFulfilled", percentageOfOrderFulfilled);
      setValue("purchaseOrderNumber", purchaseOrderNumber);

      setValue(
        "loanAmount",
        loanAmount ? Number(loanAmount).toLocaleString("en-US") : null,
      );
      setValue("loanProduct", loanProduct);
      setValue("purchaseOrderDueDate", purchaseOrderDueDate);
      setValue("transactionTimes", transactionTimes);
    }
  }, []);
  return (
    <div className={styles.purchaseOrderDetailsContainer}>
      <form>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="client"
              label="Client(Principal)"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="activeContractBuyer"
              label="Do You Have An Active Contract With The Buyer? *"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="currency"
              type="text"
              label="Currency"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="contractValue"
              type="text"
              label="Contract Value"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="purchaseOrderAmountValue"
              type="text"
              label="Purchase Order Value"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="valueOfOrderFulfilled"
              type="text"
              label="Value of Order Fulfilled"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="percentageOfOrderFulfilled"
              type="text"
              label="Percentage of Order Fulfilled %"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="purchaseOrderNumber"
              type="text"
              label="P O Number"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="loanAmount"
              type="text"
              label="Loan Amount "
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="loanProduct"
              label="Loan Product"
              reference={register}
              labelClass="label-txt form-label d-flex justify-content-between"
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="purchaseOrderDueDate"
              type="date"
              label="Purchase Order Due Date"
              reference={register}
              readOnly
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1">
            <CustomInputField
              name="transactionTimes"
              type="number"
              label="Transaction Times"
              reference={register}
              readOnly
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default PurchaseOrderDetails;
